
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BigNumber from 'bignumber.js';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import Recycle from '@/components/Recycle.vue';
import Exchange from '@/components/Exchange.vue';
import WoolStake from '@/components/WoolStake.vue';
import { totalRecycledAlpaca } from '@/contract/alpacaRecycleBox';
import { balanceOf } from '@/contract/woolToken';
import { validateAccount } from '@/utils/web3';
import { getAlpacasRecycledInfo } from '@/backend/requests';
import { ROUTE_RECYCLE_TAB } from '@/router';

@Component({
  components: {
    AlpacaBtn,
    Recycle,
    Exchange,
    WoolStake,
  },
})
export default class Stake extends Vue {
  @Prop({
    required: false,
    default: 'exchange',
  })
  public tab!: 'recycle' | 'exchange';

  public totalRecycled: string = '0';
  public myTotalRecycled: string = '0';
  public myWoolBalance: BigNumber = new BigNumber(0);
  public curTab: 'recycle' | 'exchange' = 'exchange';

  get account() {
    return this.$store.getters.getAccount;
  }

  public mounted() {
    this.curTab = this.tab;
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public async getTotalAlpacasRecycled() {
    const amount = await totalRecycledAlpaca();
    if (amount) {
      this.totalRecycled = amount;
    }
  }

  public async getAlpacasRecycledInfo() {
    const info = await getAlpacasRecycledInfo(this.account);
    if (info) {
      this.myTotalRecycled = info.data.my_recycled;
    }
  }

  public async getWoolBalance() {
    const amount = await balanceOf(this.account);
    if (amount) {
      this.myWoolBalance = new BigNumber(amount);
    }
  }

  public changeTab(tab: 'recycle' | 'exchange') {
    this.curTab = tab;
    this.$router.push({ name: ROUTE_RECYCLE_TAB, params: {tab} });
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getTotalAlpacasRecycled();
      this.getAlpacasRecycledInfo();
      this.getWoolBalance();
    }
  }
}
